import { ReactNode, use, useCallback, useEffect, useState } from "react";
import { Modal, Button, Dropdown } from "react-bootstrap";

import { Outlet, Link, router, useParams, useNavigate } from "react-router-dom";
import { AppValues, API, ApiAdmin,GetDate_ } from "../../Values";
import Cookies from "js-cookie";
export default function Privacy() {
  const navigate = useNavigate();
  const style = {
    fontSize: "14px",
    color: "#666",
    fontWeight: "bold",
  };
  const [Data, SetData] = useState([{ Address: "" }]);
  useEffect(() => {
    GetData();
  }, []);
  async function GetData() {
    try {
      const post = {
        Action: "GetCompanyInfo",
      };
      const response = await fetch(ApiAdmin + "/CompanyInfo.php", {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data = await response.json();
      // console.log(data);
      SetData(data);
    } catch (error) {
      return error;
    }
  }
  return (

    <div
      dir="rtl"
      className="row mt-0 text-center0 m-auto "
      style={{ maxWidth: "1000px" }}
    >
      <div className="col-1 py-1 bg-light " onClick={()=>navigate(-1)}>
      <i className="fa-solid fa-chevron-right  mt-2 fs-4"></i>
      </div>
      <div className="col-11 py-1 text-center bg-light">
        <h4>{" سياسة الخصوصية "}</h4>
      </div>
      <br />

      <div className="col-12 mt-0">

        <h4>سياسة الخصوصية – تطبيق توصيل الطلبات</h4>
        <p><strong dir="rtl" className="text-syan">آخر تحديث : </strong> {GetDate_.Today}</p>

        <span>
          نحن في  جى سيو اكسبريس ، نلتزم بحماية خصوصيتك وضمان سرية بياناتك الشخصية. وتوضح
          هذه السياسة كيفية قيام شركة  ( جى سيو اكسبريس ) بجمع واستخدام ومعالجة وحفظ
          وحماية بياناتك الشخصية عند استخدام خدماتنا وخياراتك فيما يتعلق بهذه
          البيانات بما يتوافق مع نظام حماية البيانات الشخصية والأنظمة ذات
          العلاقة
        </span>
        <hr></hr>
        <section>
          <h4>1. المعلومات التي نجمعها</h4>
          <p>نقوم بجمع أنواع متعددة من البيانات لتقديم خدمة توصيل آمنة وسريعة للمستخدم، وتشمل:</p>
          <ul>
            <li><strong className="text-syan">البيانات الشخصية :</strong> مثل الاسم الكامل، رقم الهاتف، وعنوان التوصيل ،  والبريد الالكترونى.</li>
            <li><strong className="text-syan">بيانات الموقع الجغرافي :</strong> تُستخدم أثناء تشغيل التطبيق لتحديد الموقع الحالي للمستخدم وتحديد المسافة بين المندوب والعميل.</li>
            <li><strong className="text-syan">بيانات الكاميرا :</strong> تُستخدم فقط لالتقاط صورة للطلب قبل التوصيل، بهدف إثبات الطلب وضمان الشفافية.</li>
            <li><strong className="text-syan">الميكروفون :</strong> نستخدمه فقط لتفعيل ميزة "البحث الصوتي" عن العناوين على الخريطة، ولا نقوم بتسجيل أو تخزين أي صوت.</li>
            <li><strong className="text-syan">الوسائط (الصور/الفيديو) :</strong> نطلب الإذن فقط إذا احتاج المستخدم إرفاق صورة مرتبطة بالطلب أو المشكلة.</li>
          </ul>
        </section>

        <section>
          <h4>2. الغرض من استخدام البيانات</h4>
          <p>نستخدم البيانات التي نجمعها من أجل:</p>
          <ul>
            <li>تحديد الموقع الجغرافي للمستخدم لتوجيه المندوب بدقة.</li>
            <li>عرض الموقع الحالي للعميل أو المندوب على الخريطة داخل التطبيق.</li>
            <li>التقاط صورة للأوردر قبل التوصيل كجزء من إثبات الطلب وضمان جودة الخدمة.</li>
            <li>السماح للمستخدم بإدخال العناوين صوتيًا لتسهيل تجربة الاستخدام.</li>
            <li>توفير إمكانية إرفاق صور أو ملاحظات للمشكلات المتعلقة بالطلبات.</li>
          </ul>
        </section>

        <section>
          <h4>3. مشاركة البيانات</h4>
          <p>لا نشارك بياناتك مع أي طرف ثالث إلا في الحالات التالية:</p>
          <ul>
            <li>مشاركة اسم العميل وموقعه مع المندوب لأغراض التوصيل فقط.</li>
            <li>مشاركة رقم المندوب مع العميل لتسهيل التواصل أثناء التوصيل.</li>
            <li>عند طلب رسمي من الجهات القانونية أو التنظيمية.</li>
          </ul>
        </section>

        <section>
          <h4>4. أمان البيانات</h4>
          <p>
            نلتزم بتطبيق أعلى معايير الأمان من خلال تشفير البيانات أثناء الإرسال، وحماية قواعد البيانات من الوصول غير المصرح به.
            لا يتم تخزين أي معلومات حساسة مثل الصور أو الموقع الجغرافي في جهاز المستخدم أو على خوادمنا بدون موافقة واضحة.
          </p>
        </section>

        <section>
          <h4>5. حقوق المستخدم</h4>
          <ul>
            <li>لك الحق في معرفة نوع البيانات التي نحتفظ بها عنك.</li>
            <li>يمكنك طلب تعديل أو حذف بياناتك من خلال التواصل معنا.</li>
            <li>يمكنك تعطيل الأذونات (الموقع، الكاميرا، إلخ) من إعدادات هاتفك في أي وقت.</li>
          </ul>
        </section>

        <section>
          <h4>6. تفاصيل الأذونات المطلوبة</h4>
          <table className="table"  border="1" cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th>اسم الإذن</th>
                <th>الغرض من الاستخدام</th>
                <th>هل يمكن الاستغناء عنه؟</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>الموقع الجغرافي (ACCESS_FINE_LOCATION)</td>
                <td>نستخدمه لتحديد مكانك بدقة وتوجيه الطلبات إلى أقرب مندوب.</td>
                <td>لا، ضروري لتحديد مواقع التوصيل.</td>
              </tr>
              <tr>
                <td>الكاميرا (CAMERA)</td>
                <td>لالتقاط صورة للطلب قبل التوصيل كوسيلة إثبات وتحسين جودة الخدمة.</td>
                <td>نعم، لكن قد لا تعمل بعض المزايا.</td>
              </tr>
              <tr>
                <td>الميكروفون (RECORD_AUDIO)</td>
                <td>يُستخدم فقط لتفعيل ميزة البحث الصوتي لتسهيل إدخال العناوين.</td>
                <td>نعم، البحث الصوتي يصبح غير مفعل فقط.</td>
              </tr>
              <tr>
                <td>الصور/الوسائط</td>
                <td>للسماح للمستخدم بإرفاق صورة أو مستند أثناء التواصل أو الإبلاغ عن مشكلة.</td>
                <td>نعم.</td>
              </tr>
              <tr>
                <td>الإنترنت</td>
                <td>لتحميل الخرائط، تحديث الطلبات، والتواصل مع خوادم التطبيق.</td>
                <td>لا، التطبيق لن يعمل بدون اتصال بالإنترنت.</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section>
          <h4>7. التعديلات على السياسة</h4>
          <p>قد نقوم بتحديث هذه السياسة من وقت لآخر. سيتم إعلام المستخدمين بأي تغييرات من خلال التطبيق أو عبر البريد الإلكتروني.</p>
        </section>

        <section>
          <h4>8. التواصل معنا</h4>
          <p>
            إذا كانت لديك أي استفسارات أو طلبات متعلقة بسياسة الخصوصية، يُرجى التواصل معنا عبر:<br /><br />
            البريد الإلكتروني: <strong className="text-syan">{Data[0].Email}</strong><br />
            رقم الهاتف: <strong className="text-syan">{Data[0].Mobil}</strong>
          </p>
        </section>
      </div>
    </div>

  );
}
